import React, { useState } from "react";
import MemberDetailForm from "./MemberDetailForm";
import { deleteMember } from "../../services/auth";

const MemberList = ({ mainUserId, members, onClose, setMembers }) => {
  const [view, setView] = useState("table");
  const [editingMember, setEditingMember] = useState(null);
  const [memberToDelete, setMemberToDelete] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleAddNew = () => {
    setEditingMember(null);
    setView("form");
  };

  const handleEdit = (user) => {
    setEditingMember(user);
    setView("form");
  };

  const handleDeleteClick = (id) => {
    setMemberToDelete(id);
    setShowDeleteConfirm(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      const result = await deleteMember(memberToDelete, mainUserId);
      if (result.success) {
        setMembers((prevMembers) =>
          prevMembers.filter((member) => member.ID !== memberToDelete)
        );
        alert("Member deleted successfully");
      } else {
        alert(result.message);
      }
    } catch (error) {
      console.error("Error deleting member:", error);
      alert("Failed to delete member. Please try again.");
    } finally {
      setShowDeleteConfirm(false);
      setMemberToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteConfirm(false);
    setMemberToDelete(null);
  };

  const handleFormClose = () => {
    setView("table");
  };

  const formatDateToDDMMYYYY = (dateStr) => {
    if (!dateStr) return "";

    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return dateStr;

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  };

  return (
    <div className="p-4 sm:p-6 md:p-8 lg:p-10 w-full">
      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl max-w-md w-full">
            <h3 className="text-lg font-semibold mb-4">Confirm Deletion</h3>
            <p className="mb-6">
              Are you sure you want to delete this member? This action cannot be
              undone.
            </p>
            <div className="flex justify-end space-x-4">
              <button
                onClick={handleDeleteCancel}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 transition"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteConfirm}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {view === "table" ? (
        <div className="flex flex-col">
          {/* Header Buttons */}
          <div className="flex flex-wrap justify-center md:justify-end gap-2 md:gap-4 mb-4">
            <button
              className="w-auto px-5 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 transition"
              onClick={handleAddNew}
            >
              + Add Member
            </button>
            <button
              onClick={onClose}
              className="w-auto px-5 py-2 bg-gray-300 rounded hover:bg-gray-400 transition"
            >
              Cancel
            </button>
          </div>

          {/* Table Wrapper */}
          {!members || members.length === 0 ? (
            <div className="text-sm text-gray-500 mb-4 text-center">
              No members added.
            </div>
          ) : (
            <div className="overflow-x-auto rounded border shadow-sm bg-white">
              <table className="min-w-[900px] w-full text-sm text-left">
                <thead className="bg-gray-100 text-gray-700 uppercase">
                  <tr>
                    <th className="px-4 py-2 border">#</th>
                    <th className="px-4 py-2 border">Name</th>
                    <th className="px-4 py-2 border">Relation</th>
                    <th className="px-4 py-2 border">Birth Date</th>
                    <th className="px-4 py-2 border">Profession</th>
                    <th className="px-4 py-2 border">Blood Group</th>
                    <th className="px-4 py-2 border">Education</th>
                    <th className="px-4 py-2 border">Marital Status</th>
                    <th className="px-4 py-2 border">Gender</th>
                    <th className="px-4 py-2 border">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {members.map((member, index) => (
                    <tr
                      key={index}
                      className="text-gray-700 hover:bg-gray-50 transition"
                    >
                      <td className="px-4 py-2 border text-center">
                        {member.ID}
                      </td>
                      <td className="px-4 py-2 border">{member.Naam}</td>
                      <td className="px-4 py-2 border">{member.Rel}</td>
                      <td className="px-4 py-2 border">
                        {formatDateToDDMMYYYY(member.bDate)}
                      </td>
                      <td className="px-4 py-2 border">{member.Prof}</td>
                      <td className="px-4 py-2 border">{member.Blood}</td>
                      <td className="px-4 py-2 border">{member.Edu}</td>
                      <td className="px-4 py-2 border">
                        {member.MrdStatus == 0
                          ? "અપરિણીત"
                          : member.MrdStatus == 1
                          ? "પરિણિત"
                          : ""}
                      </td>
                      <td className="px-4 py-2 border">
                        {member.gen == 1 ? "પુરુષ" : "સ્ત્રી"}
                      </td>
                      <td className="px-4 py-2 border text-center space-x-2">
                        <button
                          className="text-blue-600 hover:underline"
                          onClick={() => handleEdit(member)}
                        >
                          Edit
                        </button>
                        <button
                          className="text-red-600 hover:underline"
                          onClick={() => handleDeleteClick(member.ID)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ) : (
        <MemberDetailForm
          mainUserId={mainUserId}
          user={editingMember}
          onClose={handleFormClose}
          members={members}
          setMembers={setMembers}
        />
      )}
    </div>
  );
};

export default MemberList;
